module.exports = __webpack_public_path__ + "media/images/writer/maker-landscape-banner-148d113c64651b96d7e1662c4c5c94f8.png";